export default __webpack_public_path__ + "static/article-renovation-keep-your-cool-smart-hacks-6d72a82af98007b96f48dbb9b6b7b22a.jpg";